var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.44,
    height: 20.9,
    viewBox: "0 0 18.44 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "spreadsheet"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7,22.6c-.3,0-.7-.1-1-.1a3.61,3.61,0,0,1-3.2-3.1A7.08,7.08,0,0,1,2.4,18V6.4a5.54,5.54,0,0,1,.2-1.8A3.63,3.63,0,0,1,5.7,1.9a14.08,14.08,0,0,1,2-.1h5a1,1,0,1,1,.1,1.9H6.1A1.77,1.77,0,0,0,4.3,5.4V18.5a1.7,1.7,0,0,0,.1.7A1.81,1.81,0,0,0,6,20.7h8.7a5.7,5.7,0,0,0,1.3-.1,1.7,1.7,0,0,0,1.4-1.5c0-.4.1-.7.1-1.1V12.4a1.14,1.14,0,0,1,.3-.8.91.91,0,0,1,1.5.3c0,.1.1.1.1.2v6.6c0,.2-.1.5-.1.7a3.61,3.61,0,0,1-3.2,3.1c-.3,0-.7.1-1,.1Z",
    transform: "translate(-2.35 -1.75)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(8.38 7.39) rotate(-0.27)",
    fontSize: 5.5,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "xlsx"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.35 -1.75)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-2.35 -1.75)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsx-icon.4a0afbb8796f397a12de9d29c4faa2f4.svg";
export { ForwardRef as ReactComponent };